import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

export const useCanRequestReservation = (options?: SWRConfiguration) => {
  const { authUser } = useAuthUser()
  const client = useGyymClient()

  return useGyymSWR(
    authUser ? client.user.reservationRequests.canRequest : null,
    options,
  )
}
